import styled from 'styled-components';
import { BrandColor, ComplementaryColor, Spacer, mediaMinWidth } from '@lux/tokens';

export const NewDealsCarouselContainer = styled.div<{ $needsTopMargin: boolean }>`
    padding: ${Spacer.SM};
    background-color: ${BrandColor.primary};
    border-radius: ${Spacer.XS};
    overflow-x: hidden;

    ul {
        gap: ${Spacer.XS};
    }
    ${mediaMinWidth.xs} {
        margin-top: ${({ $needsTopMargin }) => ($needsTopMargin ? Spacer.M : 0)};
    }
`;

export const NewDealsBadge = styled.div`
    width: fit-content;
    padding: ${Spacer.XXS} ${Spacer.XS};
    background-color: ${ComplementaryColor.neonFresh};
    border-radius: ${Spacer.XXS};
`;

export const NewDealsCarouselHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${Spacer.M};
    padding-right: ${Spacer.XS};
    margin-top: ${Spacer.XXS};

    ${mediaMinWidth.sm} {
        justify-content: flex-start;
        gap: ${Spacer.SM};
    }
`;

export const StyledLink = styled.a`
    display: block;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
`;

export const TitleWithChevron = styled.div`
    display: flex;
    align-items: center;
    gap: ${Spacer.XS};
`;
